<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="top-list-toolbar">
          <div>
            <h4 class="text-primary">Company</h4>
            <ol class="breadcrumb breadcrumb-card-header">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);" @click="backParent">Company</a>
              </li>
              <li class="breadcrumb-item active">
                <span v-if="company.id === null">New</span>
                <span v-else>{{ company.company_no }}</span>
              </li>
            </ol>
            <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
            <button type="button" @click="updateCompany" class="btn btn-sm btn-soft-primary pull-left" v-show="company.compay_no !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
            <button type="button" @click="createCompany" class="btn btn-sm btn-soft-primary pull-left" v-show="company.company_no == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
          </div>
        </div>
      </div>
    </div>
    <div class="card card-list">
      <div class="card-header">
        <div class="col-md-12">
          <h5 class="text-primary">
            <span v-if="company.id === null">New</span>
            <span v-else>{{ company.company_no }} - {{ company.name }}</span>
          </h5>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="company.name" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="alias" class="col-sm-3 col-form-label text-left">Alias</label>
              <div class="col-sm-9">
                <input type="text" v-model="company.alias" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="email" class="col-sm-3 col-form-label text-left">Email</label>
              <div class="col-sm-9">
                <input type="text" v-model="company.email" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="tax_id" class="col-sm-3 col-form-label text-left">Tax</label>
              <div class="col-sm-9">
                <select class="form-control" v-model="company.tax_id">
                  <option v-for="t in taxList" :key="t.id" :value="t.id">{{ t.name }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
              <div class="col-sm-9">
                <input type="text" v-model="company.phone" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="npwp" class="col-sm-3 col-form-label text-left">NPWP</label>
              <div class="col-sm-9">
                <input type="text" v-model="company.npwp" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
              <div class="col-sm-9">
                <textarea rows="5" v-model="company.address" class="form-control"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <ul class="nav nav-tabs nav-bordered">
              <li class="nav-item"><a href="#setting" data-toggle="tab" aria-expanded="false" class="nav-link active">Setting</a></li>
              <li class="nav-item"><a href="#account" data-toggle="tab" aria-expanded="false" class="nav-link">Account</a></li>
              <li class="nav-item"><a href="#photo" data-toggle="tab" aria-expanded="false" class="nav-link">Photo</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="setting">
                <div class="col-md-4">
                  <div class="custom-control custom-switch" v-for="s in company.settings" :key="s.id">
                    <input type="checkbox" class="custom-control-input" :id="s.name" v-model="s.active">
                    <label class="custom-control-label" :for="s.name">{{ s.description }}</label>
                    <input type="text" v-model="s.value" class="form-control" v-if="s.value !== null" :disabled="s.active === false" />
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="account">
                <h5>Account:</h5>
              </div>
              <div class="tab-pane" id="photo">
                <div class="row">
                  <div class="col-md-6">
                    <h5>Login Background</h5>
                    <!-- <span>{{ photoBackground.url }}</span> -->
                    <div id="login-background" @click="chooseFiles">
                      <img :src="`${publicPath}asset/img/product.png`" id="login-img" class="ml-auto" v-if="photoBackground.url === null">
                      <img :src="photoBackground.url" id="login-img" class="ml-auto" v-else/>
                      <input type="file" id="file" ref="file" @change="handleFileUpload('background')" hidden/>
                    </div>
                  </div>
                </div>
                <div class="row">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
      </div>
    </div>
    <!-- <pre>{{ company }}</pre> -->
  </div>
</template>

<script>
import Axios from 'axios'
import { getHeader, companyUrl } from '../../config'
import { mapState } from 'vuex'

export default {
  name: 'CompanyForm',
  props: ['company'],
  computed: {
    ...mapState({
      bankList: state => state.banks.bankList,
      taxList: state => state.taxes.taxList
    }),
    photoBackground () {
      var photo = this.company.photos.find(d => d.tag === 'background')
      if (photo) {
        return photo
      } else {
        return {}
      }
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  methods: {
    chooseFiles () {
      document.getElementById('file').click()
    },
    async handleFileUpload (tag) {
      var photo = this.company.photos.find(d => d.tag === tag)
      this.file = this.$refs.file.files[0]
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('company_no', this.company.company_no)
      formData.append('tag', tag)
      console.log(formData)
      const newHeader = {
        'Content-Type': 'multipart/form-data'
      }
      const newObj = Object.assign(getHeader(), newHeader)
      console.log(companyUrl + '/photo')
      await Axios.post(companyUrl + '/photo', formData, { headers: newObj, timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          photo.url = response.data.data.url
        })
        .catch(error => {
          console.log(error.response)
          this.$toasted.show(error.response.data.message, {
            theme: 'toasted-primary',
            position: 'top-right',
            duration: 5000,
            icon: 'check',
            type: 'error'
          })
        })
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    updateCompany: function () {
      Axios.put(companyUrl + '/' + this.company.id, this.company, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    createCompany () {
      Axios.post(companyUrl, this.company, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>

<style>
  #login-background {
    border: 2px solid #1A1A2E;
    width: 100%;
    height: 300px;
    background-color: #fff;
    padding: 10px;
    cursor: pointer;
  }
  #login-img {
    height: 280px;
    object-fit: cover;
    /* left: 50%; */
    /* margin: -25px 0 0 -25px; */
  }
</style>
